exports.PLAYER1 = {
  UP : Phaser.KeyCode.W,
  DOWN : Phaser.KeyCode.S,
  LEFT : Phaser.KeyCode.A,
  RIGHT : Phaser.KeyCode.D,
  FIRE_UP : Phaser.KeyCode.T,
  FIRE_DOWN : Phaser.KeyCode.G,
  FIRE_LEFT : Phaser.KeyCode.F,
  FIRE_RIGHT : Phaser.KeyCode.H,
  DASH : Phaser.KeyCode.R
};

exports.PLAYER2 = {
  UP : Phaser.KeyCode.I,
  DOWN : Phaser.KeyCode.K,
  LEFT : Phaser.KeyCode.J,
  RIGHT : Phaser.KeyCode.L,
  FIRE_UP : Phaser.KeyCode.UP,
  FIRE_DOWN : Phaser.KeyCode.DOWN,
  FIRE_LEFT : Phaser.KeyCode.LEFT,
  FIRE_RIGHT : Phaser.KeyCode.RIGHT,
  DASH : Phaser.KeyCode.SHIFT
};
